import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import { getUseSharedWorker } from 'app/middleware/websocket/worker/canUseSharedWorker';
import { createAppModal } from 'utils/modal';

/**
 * A component that displays a modal when another WebSocket connection is
 * established in another tab/window.
 */
export const WebSocketConnectionChangedModal = createAppModal(
  { type: 'app:webSocketConnectionChanged' },
  ({ isOpen, hide }): JSX.Element => {
    const [useSharedWorker, setUseSharedWorker] = useState(false);

    useEffect(() => {
      getUseSharedWorker()
        .then((sharedWorkerIsEnabled) => {
          setUseSharedWorker(sharedWorkerIsEnabled);
        })
        .catch();
    }, []);

    /** Handles the modal confirm action. */
    const handleConfirm = () => {
      window.location.reload();
    };

    return (
      <Modal isOpen={isOpen} onClose={hide} allowEscClose={false}>
        <ModalHead title="Another connection has been detected" />

        <ModalBody>
          {useSharedWorker
            ? `Another connection has been detected, you may have Dixa open in another browser, the desktop app or an incognito tab.`
            : 'Another connection has been detected, you may have another browser or tab open.'}
        </ModalBody>

        <ModalFoot confirmName="Reload" confirmOnClick={handleConfirm} />
      </Modal>
    );
  },
);
